export function assignedEmployees(item) {
  const seen = new Set();

  return (item?.assignments || []).filter((assignment) => {
    const userId = assignment.userId || assignment.user?.id;

    if (!userId || !assignment.user || seen.has(userId)) {
      return false;
    }

    seen.add(userId);

    return true;
  });
}

export function assignedEmployeeCount(item) {
  return assignedEmployees(item).length;
}
